let baseURL = '';
if (process.env.NODE_ENV === 'development') {
  //测试环境境
  baseURL = 'https://file-admin-api.gymooit.cn/v1';
} else {
  //正式环境
  baseURL = 'https://file-admin-api.gymooit.cn/v1';
}
export default baseURL;